(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zorro-global-sale-bar"] && !Shopify.designMode) return;
  try {
    (function(){
    if(window.ZorroCampaign&&window.ZorroCampaign.version)return;
    var threshold=5000,lastCart=null,refreshTimer=null;
    function currency(amount){
      var code=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
      var locale=document.documentElement.lang||'en';
      try{return new Intl.NumberFormat(locale,{style:'currency',currency:code,minimumFractionDigits:2}).format(amount/100);}
      catch(error){return (amount/100).toFixed(2).replace('.',',')+' €';}
    }
    function updateCart(cart){
      if(!cart||typeof cart.total_price!=='number')return;
      lastCart=cart;
      document.querySelectorAll('[data-zorro-free-shipping]').forEach(function(node){
        var goal=Number(node.dataset.threshold||threshold),remaining=Math.max(0,goal-cart.total_price),unlocked=remaining===0;
        var template=unlocked?node.dataset.unlocked:node.dataset.remaining;
        var message=node.querySelector('[data-zfs-message]'),fill=node.querySelector('[data-zfs-fill]');
        if(message)message.textContent=(template||'').replace('%amount%',currency(remaining));
        if(fill)fill.style.width=Math.min(100,Math.max(0,cart.total_price/goal*100))+'%';
        node.classList.toggle('is-unlocked',unlocked);
      });
    }
    function refreshCart(){
      clearTimeout(refreshTimer);
      refreshTimer=setTimeout(function(){
        var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        fetch(root+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}}).then(function(response){return response.json();}).then(updateCart).catch(function(){});
      },80);
    }
    window.ZorroCampaign={version:'1.1',updateCart:updateCart,refreshCart:refreshCart};
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshCart);else refreshCart();
    document.addEventListener('click',function(event){if(event.target.closest('.header__icon--cart,[href$="/cart"],[href*="/cart?"]'))setTimeout(refreshCart,180);});
    new MutationObserver(function(records){
      var addedProgress=records.some(function(record){
        return Array.prototype.some.call(record.addedNodes,function(node){
          return node.nodeType===1&&(node.matches('[data-zorro-free-shipping]')||node.querySelector('[data-zorro-free-shipping]'));
        });
      });
      if(addedProgress&&lastCart)updateCart(lastCart);
    }).observe(document.documentElement,{childList:true,subtree:true});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-language-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const forms = Array.from(document.querySelectorAll('.zorro-language-form'));
      if (!forms.length) return;
      const save = (storageName, key, value) => { try { window[storageName].setItem(key,value); } catch (_) {} };
      const read = (storageName, key) => { try { return window[storageName].getItem(key); } catch (_) { return null; } };
      forms.forEach(form => {
        if (form.dataset.languageReady) return;
        form.dataset.languageReady = 'true';
        form.querySelector('[data-zlanguage-return]').value = location.pathname + location.search + location.hash;
        form.addEventListener('submit', event => {
          const lang = event.submitter?.value;
          if (lang === 'fi' || lang === 'en') save('localStorage','zorro-language',lang);
          save('sessionStorage','zorro-language-checked','1');
        });
      });
      if (window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id')) return;
      const current = document.documentElement.lang.split('-')[0];
      const preferred = read('localStorage','zorro-language');
      const alreadyChecked = read('sessionStorage','zorro-language-checked');
      if (!preferred && alreadyChecked) return;
      save('sessionStorage','zorro-language-checked','1');
      if (/\/(cart|checkout|account)(\/|$)/.test(location.pathname)) return;
      if (!preferred && document.referrer) { try { if (new URL(document.referrer).origin === location.origin) return; } catch (_) {} }
      const deviceLanguage = (navigator.languages?.[0] || navigator.language || 'en').toLowerCase().split('-')[0];
      const target = preferred === 'fi' || preferred === 'en' ? preferred : (deviceLanguage === 'fi' ? 'fi' : 'en');
      if (target !== current) {
        const button = forms[0].querySelector('button[value="'+target+'"]');
        if (button) forms[0].requestSubmit(button);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
    document.addEventListener('shopify:section:load',init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-mystery-box"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.ZorroMysteryBox) return;
    var cfgEl = document.getElementById('zorro-mb-config');
    if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var BOX_VARIANT = Number(cfg.variant), BOX_PRODUCT = Number(cfg.product);
    var BUNDLE_PRODUCTS = (cfg.bundleProducts || []).map(Number), BUNDLE_VARIANTS = (cfg.bundleVariants || []).map(Number);
    var available = cfg.available !== false;
    var origFetch = window.fetch.bind(window);
    var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

    /* ---- rolling 3-hour countdown, aligned to local midnight (8 windows a day) ---- */
    function p2(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var d = new Date(), s = d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds(), rem = 10800 - (s % 10800);
      var h = p2(Math.floor(rem / 3600)), m = p2(Math.floor((rem % 3600) / 60)), sec = p2(rem % 60);
      document.querySelectorAll('[data-zmb-h]').forEach(function (e) { e.textContent = h; });
      document.querySelectorAll('[data-zmb-m]').forEach(function (e) { e.textContent = m; });
      document.querySelectorAll('[data-zmb-s]').forEach(function (e) { e.textContent = sec; });
    }
    tick(); setInterval(tick, 1000);

    /* ---- keep the sticky header below the bar ---- */
    var bar = document.querySelector('[data-zmb-bar]');
    function measure() {
      var h = bar && getComputedStyle(bar).display !== 'none' ? bar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--zorro-sale-bar-height', Math.round(h) + 'px');
    }
    measure();
    if (bar && window.ResizeObserver) new ResizeObserver(measure).observe(bar);
    window.addEventListener('resize', measure); window.addEventListener('load', measure);

    function markSoldOut() { available = false; document.documentElement.setAttribute('data-zmb-soldout', ''); measure(); }

    /* ---- cart helpers (always through the original fetch so they never re-trigger the interceptor) ---- */
    function isBundleItem(it) { return BUNDLE_PRODUCTS.indexOf(Number(it.product_id)) >= 0; }
    function isBoxItem(it) { return Number(it.variant_id) === BOX_VARIANT || Number(it.product_id) === BOX_PRODUCT; }
    function boxLine() { return { id: BOX_VARIANT, quantity: 1, properties: { _zorro_gift: 'mystery-box' } }; }
    function getCart() { return origFetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
    function change(key, q) { return origFetch(root + 'cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity: q }) }).then(function (r) { return r.ok; }); }
    function addBox() { return origFetch(root + 'cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [boxLine()] }) }).then(function (r) { if (!r.ok) markSoldOut(); return r.ok; }); }

    /* ---- reconcile: box line exists (qty 1) iff a bundle line exists ---- */
    var busy = false, again = false;
    function reconcile() {
      if (busy) { again = true; return Promise.resolve(false); }
      busy = true;
      return getCart().then(function (cart) {
        var items = cart.items || [], hasBundle = items.some(isBundleItem), boxes = items.filter(isBoxItem), ops = [];
        if (!hasBundle) {
          boxes.forEach(function (b) { ops.push(function () { return change(b.key, 0); }); });
        } else if (available) {
          if (!boxes.length) ops.push(addBox);
          boxes.forEach(function (b, i) {
            if (i === 0 && b.quantity !== 1) ops.push(function () { return change(b.key, 1); });
            if (i > 0) ops.push(function () { return change(b.key, 0); });
          });
        }
        return ops.reduce(function (p, op) { return p.then(function (done) { return op().then(function (ok) { return done || ok; }); }); }, Promise.resolve(false));
      }).then(function (changed) {
        busy = false;
        if (again) { again = false; return reconcile().then(function (c2) { return changed || c2; }); }
        if (!changed) return false;
        return getCart().then(function (cart) {
          document.dispatchEvent(new CustomEvent('zorro:mysterybox:cart', { detail: cart }));
          if (window.ZorroCampaign && window.ZorroCampaign.updateCart) window.ZorroCampaign.updateCart(cart);
          return true;
        });
      }).catch(function () { busy = false; return false; });
    }
    var debounceTimer = null;
    function queueReconcile() { clearTimeout(debounceTimer); debounceTimer = setTimeout(reconcile, 120); }

    /* ---- intercept every cart mutation the storefront makes ---- */
    function bodyItems(body) {
      if (!body || typeof body !== 'object') return null;
      if (Array.isArray(body.items)) return body.items.map(function (it) { return Object.assign({}, it); });
      if (body.id !== undefined) return [{ id: body.id, quantity: body.quantity || 1, properties: body.properties }];
      return null;
    }
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCart = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
      if (!isCart) return origFetch(input, init);
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      if (isAdd && available && init && typeof init.body === 'string') {
        var parsed = null; try { parsed = JSON.parse(init.body); } catch (e) {}
        var items = bodyItems(parsed);
        var wantsBundle = items && items.some(function (it) { return BUNDLE_VARIANTS.indexOf(Number(it.id)) >= 0; });
        var hasBox = items && items.some(function (it) { return Number(it.id) === BOX_VARIANT; });
        if (wantsBundle && !hasBox) {
          items.push(boxLine());
          var combined = Object.assign({}, init, { body: JSON.stringify({ items: items }) });
          return origFetch(input, combined).then(function (r) {
            if (r.ok) { queueReconcile(); return r; }
            /* the combined add failed - never block the bundle: retry the customer's original request as-is */
            return origFetch(input, init).then(function (r2) { if (r2.ok) markSoldOut(); queueReconcile(); return r2; });
          });
        }
      }
      return origFetch(input, init).then(function (r) { queueReconcile(); return r; });
    };

    /* ---- cart page is a plain form post: never let a box reach checkout without its bundle ---- */
    var cartForm = document.querySelector('.zcart-form');
    if (cartForm) cartForm.addEventListener('submit', function () {
      var bundleQty = 0, boxInputs = [];
      cartForm.querySelectorAll('.zcart-line').forEach(function (line) {
        var pid = Number(line.getAttribute('data-product-id')), inp = line.querySelector('input[name="updates[]"]');
        if (!inp) return;
        if (BUNDLE_PRODUCTS.indexOf(pid) >= 0) bundleQty += Number(inp.value) || 0;
        if (pid === BOX_PRODUCT) boxInputs.push(inp);
      });
      if (bundleQty === 0) boxInputs.forEach(function (i) { i.value = 0; });
    });

    /* ---- on load: live stock check, then straighten out whatever the cart already holds ---- */
    origFetch(root + 'products/' + cfg.handle + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.available === false) markSoldOut(); })
      .catch(function () {})
      .then(reconcile)
      .then(function (changed) {
        if (changed && /\/cart\/?$/.test(location.pathname)) location.reload();
      });

    window.ZorroMysteryBox = { reconcile: reconcile, config: cfg };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-product-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-zproduct-nav]').forEach((nav) => {
        if (nav.dataset.ready) return;
        const track = document.getElementById(nav.dataset.zproductNav);
        if (!track) return;
        const cards = Array.from(track.children).filter((el) => el.classList.contains('pcard'));
        if (!cards.length) { nav.hidden = true; return; }
        nav.dataset.ready = 'true';
        const prev = nav.querySelector('[data-zproduct-prev]');
        const next = nav.querySelector('[data-zproduct-next]');
        const count = nav.querySelector('[data-zproduct-count]');
        const mobile = window.matchMedia('(max-width: 767px)');
        const positions = () => {
          const start = track.getBoundingClientRect().left;
          const max = track.scrollWidth - track.clientWidth;
          return cards.map((card) => Math.min(max, Math.max(0, card.getBoundingClientRect().left - start + track.scrollLeft)));
        };
        const current = () => {
          const offsets = positions();
          return offsets.reduce((best, value, i) => Math.abs(value - track.scrollLeft) < Math.abs(offsets[best] - track.scrollLeft) ? i : best, 0);
        };
        const sync = () => {
          const i = current();
          count.textContent = `${i + 1} / ${cards.length}`;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        const move = (direction) => {
          if (!mobile.matches) return;
          const i = Math.max(0, Math.min(cards.length - 1, current() + direction));
          track.scrollTo({ left: positions()[i], behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        prev.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', sync, { passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || !mobile.matches) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        mobile.addEventListener('change', sync);
        window.addEventListener('resize', sync, { passive: true });
        sync();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-snap-carousel"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(sc){
      if(sc.__zsnap)return;sc.__zsnap=true;
      var track=sc.querySelector('[data-zsnap-track]'),prev=sc.querySelector('[data-zsnap-prev]'),next=sc.querySelector('[data-zsnap-next]'),dots=sc.querySelector('[data-zsnap-dots]'),raf=0;
      if(!track)return;
      function cards(){return [].slice.call(track.children);}
      function step(){var c=cards();return c.length>1?c[1].offsetLeft-c[0].offsetLeft:track.clientWidth||1;}
      function perView(){return Math.max(1,Math.round(track.clientWidth/step()));}
      function positions(){return Math.max(1,cards().length-perView()+1);}
      function idx(){return Math.min(positions()-1,Math.round(track.scrollLeft/step()));}
      function go(i){track.scrollTo({left:Math.max(0,Math.min(i,positions()-1))*step(),behavior:'smooth'});}
      function buildDots(){
        if(!dots)return;var n=positions();if(dots.children.length===n)return;
        dots.innerHTML='';
        for(var k=0;k<n;k++){var b=document.createElement('button');b.type='button';b.setAttribute('role','tab');b.setAttribute('aria-label',(k+1)+' / '+n);b.addEventListener('click',go.bind(null,k));dots.appendChild(b);}
      }
      function sync(){
        buildDots();
        var i=idx(),can=positions()>1,max=track.scrollWidth-track.clientWidth-2;
        sc.classList.toggle('is-scrollable',can);
        if(prev)prev.disabled=track.scrollLeft<=2;
        if(next)next.disabled=track.scrollLeft>=max;
        if(dots){dots.hidden=!can;[].forEach.call(dots.children,function(d,k){d.classList.toggle('on',k===i);d.setAttribute('aria-selected',k===i);});}
      }
      function queue(){cancelAnimationFrame(raf);raf=requestAnimationFrame(sync);}
      if(prev)prev.addEventListener('click',function(){go(idx()-1);});
      if(next)next.addEventListener('click',function(){go(idx()+1);});
      // scroll is high-frequency, so it is coalesced per frame; everything else
      // syncs directly so a throttled rAF (background tab) cannot leave stale state
      track.addEventListener('scroll',queue,{passive:true});
      window.addEventListener('resize',sync);
      window.addEventListener('load',sync);
      if(window.ResizeObserver)new ResizeObserver(sync).observe(track);
      if(window.MutationObserver)new MutationObserver(sync).observe(track,{childList:true});
      sync();
    }
    function initAll(){document.querySelectorAll('[data-zsnap]').forEach(init);}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
    document.addEventListener('shopify:section:load',initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zorro-story-video"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-zorro-story]').forEach(function (story) {
    var preview = story.querySelector('[data-zorro-story-preview]');
    var openButton = story.querySelector('[data-zorro-story-open]');
    var dialog = story.querySelector('[data-zorro-story-dialog]');
    var fullVideo = story.querySelector('[data-zorro-story-full]');
    var closeButton = story.querySelector('[data-zorro-story-close]');

    if (!preview || !openButton || !dialog || !fullVideo || !closeButton) return;

    var closeStory = function () {
      fullVideo.pause();
      if (dialog.open) dialog.close();
      preview.currentTime = fullVideo.currentTime || 0;
      preview.muted = true;
      preview.play().catch(function () {});
    };

    openButton.addEventListener('click', function () {
      preview.pause();
      fullVideo.currentTime = preview.currentTime || 0;
      fullVideo.muted = false;
      dialog.showModal();
      fullVideo.play().catch(function () {});
    });

    closeButton.addEventListener('click', closeStory);
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeStory();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeStory();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
